import { TeamMember } from '@demind-inc/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TeamInviteAcceptReq, teamApi } from '../api';
import { TEAM_DAY_QUERY_KEY, TEAM_DETAIL_QUERY_KEY, TEAM_LIST_QUERY_KEY } from '../queries';

interface AcceptTeamInviteResult {
  teamId: string;
  membership: TeamMember;
}

export const useAcceptTeamInvite = () => {
  const queryClient = useQueryClient();

  const acceptTeamInviteMutation = useMutation({
    mutationFn: (teamInviteAcceptReq: TeamInviteAcceptReq) => {
      return teamApi.acceptTeamInvite(teamInviteAcceptReq).then(({ data }) => {
        return {
          teamId: data.teamId as string,
          membership: data.membership as TeamMember,
        } as AcceptTeamInviteResult;
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEAM_LIST_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_DETAIL_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_DAY_QUERY_KEY });
    },
  });

  return {
    acceptTeamInvite: acceptTeamInviteMutation.mutateAsync,
    isAcceptingTeamInvite: acceptTeamInviteMutation.isPending,
    ...acceptTeamInviteMutation,
  };
};
